import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#rowspan-and-colspan" }),
  /*#__PURE__*/_createTextVNode(" Rowspan and colspan ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Configuring rowspan and colspan allows you to merge cells ", -1)
const _hoisted_4 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", null, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          "span-method": _ctx.arraySpanMethod,
          border: "",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "ID",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "Name"
            }),
            _createVNode(_component_el_table_column, {
              prop: "amount1",
              sortable: "",
              label: "Amount 1"
            }),
            _createVNode(_component_el_table_column, {
              prop: "amount2",
              sortable: "",
              label: "Amount 2"
            }),
            _createVNode(_component_el_table_column, {
              prop: "amount3",
              sortable: "",
              label: "Amount 3"
            })
          ]),
          _: 1
        }, 8, ["data", "span-method"]),
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          "span-method": _ctx.objectSpanMethod,
          border: "",
          style: {"width":"100%","margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "id",
              label: "ID",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "name",
              label: "Name"
            }),
            _createVNode(_component_el_table_column, {
              prop: "amount1",
              label: "Amount 1"
            }),
            _createVNode(_component_el_table_column, {
              prop: "amount2",
              label: "Amount 2"
            }),
            _createVNode(_component_el_table_column, {
              prop: "amount3",
              label: "Amount 3"
            })
          ]),
          _: 1
        }, 8, ["data", "span-method"])
      ]),
      _createVNode(_component_CodeHighlighter, {
        "field-height": 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code19), 1)
        ]),
        _: 1
      })
    ])
  ]))
}